import { API_URL } from '../../../constants';
import makeUrl from '../../utils/makeUrl';
import _fetch from '../../_fetch';

export default function fetchNdes(options = {}) {
  return function withContext(context) {
    const { body, ...restOptions} = options;
    const url = makeUrl(API_URL, 'ndes/search', restOptions);

    const config = {
      method: 'POST',
      body: JSON.stringify(body || {}),
      headers: {
        'Accept': 'application/json;charset=utf-8',
        'Content-Type': 'application/json;charset=utf-8'
      },
      ...options.reqConfig
    };

    return _fetch(url, {
      withAuth: false,
      ...options
    }, config)(context);
  };
}
